import { gql } from "@apollo/client"
import { api } from "lib/graphql/api"
import { query } from "lib/graphql/query"

export const getTailoredScheduleNodeIds = api(async function getTailoredScheduleNodeIds({
    regimeId,
    includeGroupNodes,
}) {
    if (!regimeId) return []
    return query(
        gql`
            query GetTailoredScheduleNodeIds($regimeId: String!, $includeGroupNodes: Boolean) {
                getTailoredScheduleNodeIds(regimeId: $regimeId, includeGroupNodes: $includeGroupNodes)
            }
        `,
        { regimeId, includeGroupNodes },
        { returns: "getTailoredScheduleNodeIds" }
    )
})
